import textData from "../textData.json";

export type BreadcrumbRoute = {
  path: string;
  text: string;
};

export function getBreadcrumbRoutes(langState: "eng" | "fr"): BreadcrumbRoute[] {
  return [
    { path: "/", text: textData.Pages.Dashboard.Home[langState] },
    { path: "/dashboard", text: textData.Pages.Dashboard.Dashboard[langState] },
    { path: "/dashboard/profile", text: textData.Pages.Dashboard.Profile[langState] },
    { path: "/dashboard/settings", text: textData.Pages.Dashboard.Settings[langState] },

    /* Founder */
    { path: "/dashboard/founder-services", text: textData.Pages.Dashboard.Services[langState] },
    { path: "/dashboard/founder-services/:programId", text: textData.Pages.Dashboard.ServiceDetails[langState] },
    { path: "/dashboard/enrolled-services", text: textData.Pages.Dashboard.MyServices[langState] },
    { path: "/dashboard/enrolled-services/:programId", text: textData.Pages.Dashboard.MyServiceDetails[langState] },
    { path: "/dashboard/founder-applications", text: textData.Pages.Dashboard.MyApplications[langState] },
    { path: "/dashboard/application", text: textData.Pages.Dashboard.Application[langState] },
    { path: "/dashboard/education", text: textData.Pages.Dashboard.IpEducation[langState] },
    { path: "/dashboard/learning-pathway", text: textData.Pages.Dashboard.LearningPathway[langState] },
    { path: "/dashboard/program-details", text: textData.Pages.Dashboard.ProgramDetails[langState] },
    { path: "/dashboard/help", text: textData.Pages.Dashboard.Help[langState] },
    { path: "/dashboard/help/glossary", text: textData.Pages.Help.Glossary[langState] },
    { path: "/dashboard/help/contact-us", text: textData.Pages.ContactUs.ContactUs[langState] },
    { path: "/dashboard/faq", text: textData.Pages.Dashboard.Faq[langState] },
    { path: "/dashboard/resources", text: textData.Pages.Dashboard.Resources[langState] },
    { path: "/dashboard/preferences", text: textData.Pages.FounderSettings.Title[langState] },

    // Service Provider Firm
    { path: "/dashboard/founder-sp-firms", text: textData.Pages.Dashboard.IPServicesFirm[langState] },
    { path: "/dashboard/founder-sp-firms/:firmId", text: textData.Pages.Dashboard.FirmDetails[langState] },

    /* Admin */
    { path: "/dashboard/founders-no-profile", text: "Companies With No Profile" },
    { path: "/dashboard/memberships", text: "Companies" },
    { path: "/dashboard/memberships/:memberId", text: "Companies Details" },
    { path: "/dashboard/membership-applications", text: "Applications" },
    { path: "/dashboard/membership-applications/:applicationId", text: "Application Details" },
    { path: "/dashboard/services", text: "Services" },
    { path: "/dashboard/services/:programId", text: "Service Details" },
    { path: "/dashboard/my-services", text: "My Services" },
    { path: "/dashboard/my-services/:programId", text: "Service Details" },
    { path: "/dashboard/my-services/new-service", text: "New Service" },
    { path: "/dashboard/sow-invite", text: "Screened Companies" },
    { path: "/dashboard/all-sows", text: "All SoWs" },
    { path: "/dashboard/all-sows/:sowId", text: "SoW Details" },
    { path: "/dashboard/invitations", text: "Invitation History" },
    { path: "/dashboard/admin-invoices", text: "Invoices" },
    { path: "/dashboard/admin-expert-premeeting", text: "Pre Meeting" },
    { path: "/dashboard/admin-expert-in-progress", text: "Meetings In Progress" },
    { path: "/dashboard/admin-expert-recommendations", text: "IP Advisor Recommendations" },
    { path: "/dashboard/admin-expert-recommendations/:memberId", text: "Recommendation Details" },
    { path: "/dashboard/admin-dd-application", text: "In Due Diligence Assessments" },
    { path: "/dashboard/admin-dd-application/:memberId", text: "Details" },
    { path: "/dashboard/admin-coach-in-progress", text: "Awaiting Assessment" },
    { path: "/dashboard/audits", text: "Audits" },
    { path: "/dashboard/pending-applications", text: "Pending Applications" },
    { path: "/dashboard/rejection-ready", text: "Rejection Ready" },
    { path: "/dashboard/admin-invoices", text: "Invoices" },
    { path: "/dashboard/admin-invoices/:invoiceId", text: "Invoice Details" },
    { path: "/dashboard/admin-coach-premeeting", text: "Coach Pre-Meeting" },
    { path: "/dashboard/admin-coach-premeeting/:memberId", text: "Coach Pre-Meeting Details" },
    { path: "/dashboard/admin-coach-in-progress/:memberId", text: "Coaching Details" },
    { path: "/dashboard/email-logs", text: "Email Logs" },
    { path: "/dashboard/email-logs/:logId", text: "Email Log Details" },
    { path: "/dashboard/email-templates", text: "Email Templates" },
    { path: "/dashboard/email-templates/new", text: "New Template" },
    { path: "/dashboard/email-templates/:templateId", text: "Template Details" },
    { path: "/dashboard/email-templates/:templateId/edit", text: "Edit Template" },
    { path: "/dashboard/email-templates/:templateId/versions", text: "Template Versions" },
    { path: "/dashboard/growth-coach-assessment/:memberId", text: "Growth Coach Assessment" },
    { path: "/dashboard/growth-coach-in-progress", text: "Growth Coach In Progress" },
    { path: "/dashboard/growth-coach-reporting", text: "Growth Coach Reporting" },
    { path: "/dashboard/growth-coach-verification", text: "Growth Coach Verification" },

    // Super Admin
    { path: "/dashboard/admin-list", text: "Admin List" },
    { path: "/dashboard/new-user", text: "New User" },

    // Temp
    { path: "/dashboard/admin-verification", text: "Verification" },
    { path: "/dashboard/expert-verification", text: "Verification" },
    { path: "/dashboard/provider-verification", text: "Verification" },

    // Service Provider Firm (Admin)
    { path: "/dashboard/sp-firms", text: "Service Provider Firms" },
    { path: "/dashboard/sp-firms/:firmId", text: "Firm Details" },

    // Service Provider
    { path: "/dashboard/firm-profile", text: "Firm Profile" },
    { path: "/dashboard/practitioners", text: "Practitioners" },
    { path: "/dashboard/statement-of-work", text: "Scope of Work" },
    { path: "/dashboard/statement-of-work/:sowId", text: "SoW Details" },
    { path: "/dashboard/invoices", text: "Invoices" },
    { path: "/dashboard/invoices/:sowId", text: "Create Invoice" },
    { path: "/dashboard/invoice/:invoiceId", text: "Invoice Details" },

    // Expert
    { path: "/dashboard/all-assessments", text: "All Assessments" },
    { path: "/dashboard/expert-assessments", text: "Companies Awaiting Assessment" },
    { path: "/dashboard/expert-assessments/:id", text: "Assessment Details" },
    { path: "/dashboard/in-progress-assesments", text: "In Progress Assessments" },
    { path: "/dashboard/in-progress-assesments/:id", text: "Assessments Details" },
    { path: "/dashboard/submitted-assesments", text: "Submitted Assessments" },
    { path: "/dashboard/submitted-assesments/:id", text: "Assessments Details" },
    { path: "/dashboard/in-dd-application", text: "In Due Diligence Assessments" },
    { path: "/dashboard/in-dd-assesments", text: "In Due Diligence Assessments" },
    { path: "/dashboard/admin-coach-recommendations", text: "Growth Coach Recommendations" },
    { path: "/dashboard/admin-coach-recommendations/:memberId", text: "Recommendation Details" },
  ];
}
